import React, { FC, useEffect } from 'react';
import type {
    ErrorNotificationProps,
} from '~/src/components/common-components/error-notification/error-notification.types';
import { SvgErrorCross } from '~/src/components/svg-components/error-cross';
import * as Styled from './error-notification.styles';

export const ErrorNotification: FC<ErrorNotificationProps> = ({ children, callbackAfterShow }) => {
    const timeOutTime = 2000;

    useEffect(() => {
        const timeOut = setTimeout(() => {
            callbackAfterShow();
        }, timeOutTime);

        return () => {
            clearTimeout(timeOut);
        };
    }, []);

    return (
        <Styled.ErrorNotificationContainer role={'alert'}>
            <Styled.ErrorNotificationWrap>
                <Styled.IconWrapper>
                    <SvgErrorCross />
                </Styled.IconWrapper>
                <Styled.Text>{children}</Styled.Text>
            </Styled.ErrorNotificationWrap>
        </Styled.ErrorNotificationContainer>
    );
};
